'use client';

import clsx, { type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import DOMPurify from 'dompurify';
import { Decision, ProductQuotes } from "@vertical-insure/shared";

const { sanitize } = DOMPurify;

export function cx(...args: ClassValue[]) {
  return twMerge(clsx(...args))
}

export const focusRing = [
  // base
  "outline outline-offset-2 outline-0 focus-visible:outline-2",
  // outline color
  "outline-blue-500 dark:outline-blue-500",
]

export const hasErrorInput = [
  // base
  "ring-2",
  // border color
  "border-red-500 dark:border-red-700",
  // ring color
  "ring-red-200 dark:ring-red-700/30",
]

export const focusInput = [
  // base
  "focus:ring-2",
  // ring color
  "focus:ring-blue-200 dark:focus:ring-blue-700/30",
  // border color
  "focus:border-blue-500 dark:focus:border-blue-700",
]

export function formatCents(value: number, currency: string) {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
  });

  return formatter.format(value / 100);
}

if (typeof window !== 'undefined') {
  DOMPurify.addHook('afterSanitizeAttributes', function (node) {
    // set all elements owning target to target=_blank
    if ('target' in node) {
      node.setAttribute('target', '_blank');
      node.setAttribute('rel', 'noopener');
    }
  });
}

export function resetOffer() {
  localStorage.removeItem('_vi_offer_id');

  const keysToRemove = Object.keys(localStorage).filter(key => key.startsWith('_vi_quote'));
  keysToRemove.forEach(key => localStorage.removeItem(key));
}

export const areSetsEqual = (a: Set<number>, b: Set<number>) => a.size === b.size && [...a].every(value => b.has(value));

export const getQuoteCount = (productQuotes: ProductQuotes) => {
    const singleQuoteCount = productQuotes.filter(q => 'quote_id' in q).length;
    const decisionQuoteCount = productQuotes.filter(q => 'decisions' in q)
      .map(q => q.decisions.map((d: Decision) => d.options).flat()).flat()
      .filter(q => q.status === 'success').length;
    return decisionQuoteCount + singleQuoteCount;
}

export function parseBadRequestErrorMessage(message: string): string {
  if (message.includes(':')) {
    const parts = message.split(':');
    return parts.length > 1 ? parts[1] : message;
  }

  return message;
}

export { sanitize };
